import React from "react";
import { useState, useRef, useEffect } from "react";
import EmrConfigService from "../../../../services/EmrConfigService";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import FieldsDisplay from "../EmrPages/FieldsDisplay";
import EmrFormRender from "../EmrPages/EmrFormRender";
import SearchHistory from "../EmrPages/SearchHistory";
import IcdDisplay from "./IcdDisplay";
import AssessmentForm from "./AssessmentForm";

const AssesmentTab = (props) => {
  const {
    selectedSubTab,
    visit_id,
    setExpandedSection,
    fetchProgressNotesByScreen,
    Loader,
    Toast,
    employeeId,
    expandedSection,
    selectedTab,
    setSelecetedBodyParts,
  } = props;

  // === State ===
  const [fields, setFields] = useState([]);
  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const [formResponses, setFormResponses] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [progressApiTrigger, setProgressApiTrigger] = useState(0);
  const [fieldSearched, SetFieldSearched] = useState(false);
  const [activeSearchSource, setActiveSearchSource] = useState(null);
  const [normalCheckedFormIds, setNormalCheckedFormIds] = useState([]);
  const [formStates, setFormStates] = useState({});

  // === Refs ===
  const searchTimeoutRef = useRef(null);
  const historyRef = useRef(null);
  const formCache = useRef({});

  // === Effects ===
  // useEffect(() => {
  //   if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
  //   searchTimeoutRef.current = setTimeout(() => {
  //     if (searchTerm.trim() === "") fetchEmrList();
  //     else handleSearch();
  //   }, 500);
  //   return () => clearTimeout(searchTimeoutRef.current);
  // }, [searchTerm]);

  useEffect(() => {
    // fetchEmrList();
    setSearchTerm("");
  }, [selectedSubTab]);

  useEffect(() => {
    fetchProgressNotesByScreen();
  }, [visit_id, progressApiTrigger, selectedSubTab]);

  // useEffect(() => {
  //   fetchEmrList();
  // }, [props.selectedBodyPart]);

  const fetchFormDataById = async (apikey, id) => {
    // if (formCache.current[id]) return formCache.current[id];
    try {
      const response = await EmrConfigService.getEmrFormById(apikey, id);
      formCache.current[id] = response?.data;
      return response?.data;
    } catch (error) {
      console.error(`Failed to fetch form for ID: ${id}`, error);
      return null;
    }
  };

  const handleSearch = async (id, value, shouldSetFields = true) => {
    try {
      const payload = {
        field_search: searchTerm || "",
        common_search: "",
        history_value_search: "",
        id,
        value,
      };
      const results = await EmrVisitsService.fetchFieldsBySearch(
        null,
        selectedSubTab,
        payload
      );

      if (shouldSetFields) {
        const fieldsData = (results.data?.data || []).map((item) => ({
          emr_form_id: item.emr_form_id,
          name: item.name,
        }));
        SetFieldSearched(true);
        setFields(fieldsData);
      }
    } catch (err) {
      console.error("Search failed:", err);
    }
  };

  // const fetchEmrList = async () => {
  //   try {
  //     const response = await EmrVisitsService.getEmrChartByScreen(
  //       selectedSubTab,
  //       visit_id,
  //       { is_active: 1, selected_BodyParts: props.selectedBodyPart || "" }
  //     );
  //     let fieldsData = [];
  //     let selectedIds = [];
  //     let normalIds = [];
  //     response.data.forEach((itm) => {
  //       fieldsData.push({ emr_form_id: itm.emr_form_id, name: itm.name });
  //       if (itm.is_chart) selectedIds.push(itm.emr_form_id);
  //       if (itm.is_normal) normalIds.push(itm.emr_form_id);
  //       if (itm.is_chart) handleCheckboxChange(itm.emr_form_id, true);
  //     });
  //     setSelectedFormIds(selectedIds);
  //     setNormalCheckedFormIds(normalIds);
  //     setFields(fieldsData);
  //     return fieldsData;
  //   } catch (e) {
  //     console.error("Fetch EMR Error:", e);
  //     return [];
  //   }
  // };

  const handleCheckboxChange = async (
    emr_form_id,
    checked,
    replace = false
  ) => {
    setSelectedFormIds((prev) =>
      checked
        ? Array.from(new Set([...prev, emr_form_id]))
        : prev.filter((id) => id !== emr_form_id)
    );

    if (checked) {
      try {
        const form = await fetchFormDataById(selectedSubTab, emr_form_id);
        const filledDataRes = await EmrVisitsService.fetchFilledFieldData(
          null,
          visit_id,
          emr_form_id
        );
        const filledFields = filledDataRes?.data?.data?.emr_field || [];
        const filledFieldMap = {};
        filledFields.forEach((field) => {
          field.id.forEach((id) => {
            filledFieldMap[id] = field.value;
          });
        });
        const prefilledForm = {
          ...form,
          fields: form.fields.map((field) => ({
            ...field,
            prefillValue: filledFieldMap[field.id] || "",
          })),
        };
        setFormResponses((prev) => {
          if (replace) return { ...prev, [selectedSubTab]: [prefilledForm] };
          const prevList = prev[selectedSubTab] || [];
          if (
            prevList.some(
              (formItem) => formItem.emr_form_id === prefilledForm.emr_form_id
            )
          )
            return prev;
          return { ...prev, [selectedSubTab]: [...prevList, prefilledForm] };
        });
      } catch (error) {
        console.error("Error fetching prefilled field data:", error);
      }
    } else {
      handleNormalSubmit(emr_form_id, 0, 1);
      setFormResponses((prev) => {
        const updated = (prev[selectedSubTab] || []).filter(
          (form) => form?.emr_form_id !== emr_form_id
        );
        return { ...prev, [selectedSubTab]: updated };
      });
    }
  };

  const handleNormalSubmit = async (form_id, isNormal = 0, is_clear = 0, clearAll = 0) => {
    try {
      const payload = {
        employee_id: employeeId,
        screen_type: selectedSubTab,
        emr_field: "",
        is_normal: isNormal,
        chart_update: 0,
        is_clear: is_clear,
        clear_all: clearAll, // Add clear_all parameter
      };
      Loader(true);
      const result = await EmrVisitsService.saveFields(
        null,
        visit_id,
        form_id,
        payload
      );
      Loader(false);
      if (result?.status === 200 || result?.status === "SUCCESS") {
        if (isNormal === 1) {
          Toast.success("Marked as normal successfully.");
          fetchProgressNotesByScreen();
        }
      } else {
        Toast.error("Failed to mark as normal.");
      }
    } catch (err) {
      Loader(false);
      console.error("Normal save failed:", err);
      Toast.error("Something went wrong.");
    }
  };

  const handleFormUpdate = async (form_id) => {
    try {
      const form = await fetchFormDataById(selectedSubTab, form_id);
      const filledDataRes = await EmrVisitsService.fetchFilledFieldData(
        null,
        visit_id,
        form_id
      );
      const filledFields = filledDataRes?.data?.data?.emr_field || [];
      const filledFieldMap = {};
      filledFields.forEach((field) => {
        field.id.forEach((id) => {
          filledFieldMap[id] = field.value;
        });
      });
      const updatedForm = {
        ...form,
        fields: form.fields.map((field) => ({
          ...field,
          prefillValue: filledFieldMap[field.id] || "",
        })),
      };
      setFormResponses((prev) => {
        const prevList = prev[selectedSubTab] || [];
        const updatedList = prevList.map((f) =>
          f.emr_form_id === form_id ? updatedForm : f
        );
        return { ...prev, [selectedSubTab]: updatedList };
      });
    } catch (err) {
      console.error("Failed to refresh filled form:", err);
    }
  };

  const allSelected =
    fields.length > 0 &&
    fields.every((f) => selectedFormIds.includes(f.emr_form_id));

  const [selectedIcdCodes, setSelectedIcdCodes] = useState([]);

  const handleToggleIcd = async (
    icdCode,
    isChecked,
    assessment_id,
    icd10_id,
    body_parts
  ) => {
    console.log(
      "icdCode",
      icdCode,
      "isChecked",
      isChecked,
      "assessment_id",
      assessment_id,
      "icd10_id",
      icd10_id
    );

    if (!icdCode || !icd10_id) {
      console.warn("Missing ICD code or ID");
      return;
    }

    if (isChecked) {
      let prefilledData = {};

      if (assessment_id) {
        try {
          const res = await EmrVisitsService.getAssessmentDataById(null, visit_id, assessment_id);
          prefilledData = res?.data || {};
        } catch (err) {
          console.error(`Failed to fetch data for ICD ${icdCode}:`, err);
        }
      }

      const normalizeList = (val) =>
        typeof val === "string" ? val.split(",").map((v) => v.trim()) : [];

      const normalized = {
        ...prefilledData,
        condition: normalizeList(prefilledData.condition),
        existing_problem: normalizeList(prefilledData.existing_problem),
        new_problem: normalizeList(prefilledData.new_problem),
      };

      setFormStates((prev) => ({
        ...prev,
        [icdCode]: normalized,
      }));

      setSelectedIcdCodes((prev) => {
        const alreadyExists = prev.some((item) => item.code === icdCode);
        if (alreadyExists) return prev;
        return [...prev, { code: icdCode, icd_id: icd10_id ,body_parts:body_parts}];
      });
    } else {
      setSelectedIcdCodes((prev) =>
        prev.filter((item) => item.code !== icdCode)
      );

      setFormStates((prev) => {
        const copy = { ...prev };
        delete copy[icdCode];
        return copy;
      });
    }
  };

  return (
    <div className="sh_cardBody" style={{ height: "calc(40vh - 120px)" }}>
      <div className="row">
        <IcdDisplay 
        isrenderICD={props.isrenderICD}
        bodyparts={props.selectedBodyPart}
        onToggle={handleToggleIcd}
        selectedCodes={selectedIcdCodes}
        visit_id={visit_id}
        setSelecetedBodyParts={setSelecetedBodyParts}
        setSelectedIcdCodes={setSelectedIcdCodes}
        Loader={Loader}
        Toast={Toast}
        /> 
        {/* second column */}
        {/* <FieldsDisplay
          fields={fields}
          normalCheckedFormIds={normalCheckedFormIds}
          handleNormalSubmit={handleNormalSubmit}
          setNormalCheckedFormIds={setNormalCheckedFormIds}
          setSelectedFormIds={setSelectedFormIds}
          selectedFormIds={selectedFormIds}
          handleCheckboxChange={handleCheckboxChange}
          fieldSearched={fieldSearched}
          handleSearch={handleSearch}
          SetFieldSearched={SetFieldSearched}
          allSelected={allSelected}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setActiveSearchSource={setActiveSearchSource}
          activeSearchSource={activeSearchSource}
          selectedTab={selectedTab}
        /> */}

        {/* third column */}
        {/* <EmrFormRender
          setProgressApiTrigger={setProgressApiTrigger}
          fetchProgressNotesByScreen={fetchProgressNotesByScreen}
          fields={(formResponses[selectedSubTab] || []).filter((form) =>
            selectedFormIds.includes(form.emr_form_id)
          )}
          visit_id={visit_id}
          employeeId={employeeId}
          Toast={Toast}
          expandedSection={expandedSection}
          setExpandedSection={setExpandedSection}
          selectedSubTab={selectedSubTab}
          onFormUpdate={handleFormUpdate}
          isAssessment={true}
        /> */}
        <AssessmentForm
          visit_id={visit_id}
          Toast={Toast}
          employee_id={employeeId}
          selectedIcdCodes={selectedIcdCodes}
          formStates={formStates}
          setFormStates={setFormStates}
          setProgressApiTrigger={setProgressApiTrigger}
        />
      </div>
    </div>
  );
};

export default AssesmentTab;
